<template>
  <div class="header">
    <div class="wrap">
      <img :src="navList[navActive].logo" alt="" class="logo" />
      <div class="menu">
        <span
          class="menu-item"
          :class="{ active: index === navActive }"
          v-for="(item, index) in navList"
          :key="index"
          @click="chooseNav(item, index)"
          >{{ item.text }}</span
        >
      </div>
      <!-- <div class="href">
        <a class="href-item" href="https://i.58tools.cn" target="_blank"
          >代理注册</a
        >
        <a class="href-item" href="https://i.58tools.cn" target="_blank"
          >后台登录</a
        >
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "GoStart",
  data() {
    return {
      navActive: 0,
      navList: [
        {
          text: "熊猫快启",
          path: "/",
          logo: require("@/assets/images/gostart/logo.png")
        },
        {
          text: "云菜单",
          path: "https://ycd.xmgjx.cn/",
          logo: require("@/assets/images/logo.png")
        }
      ]
    };
  },
  methods: {
    chooseNav(item, index) {
      if (item.text === "云菜单") {
        window.open(item.path, "_blank");
      } else {
        this.navActive = index;
        this.$router.push(item.path);
      }
    }
  },
  mounted() {
    const { path } = this.$route;
    this.navList.map((item, index) => {
      if (item.path === path) {
        this.navActive = index;
      }
    });
  }
};
</script>

<style lang="less" scoped>
@import "./header.less";
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue